export enum OrderReceiptType {
  CLIENT = 'client',
  CONTRACT = 'contract',
  ORIGINAL = 'original',
  INTERNAL = 'internal',
}
